import { bool, func, number, object, string } from 'prop-types';
import React, { useState } from 'react';

import Titled from '../../layout/Titled';
import api from '../../REST/api';
import AuthorizedLink from '../../REST/AuthorizedLink';
import { listColumns } from '../contact-columns';
import AddToContactListModal from '../contact-lists/AddToContactListModal';
import ExportContacts from '../ExportContacts';
import AsyncList from '../List/AsyncList';
import UploadContactButton from '../UploadContacts/UploadContactsButton';

const ListContacts = ({
  titleSize,
  selectListAction: SelectListAction,
  showAddContactButton,
  showUploadButton,
  title,
  onDownload,
  additionalAddFormProps,
  search,
  contactListId,
  ...rest
}) => {
  const searchParams = { contactListId, ...search };

  const [selectedContactIds, setContactIds] = useState([]);
  const [data, setData] = useState([]);
  const [tableFilters, setTableFilters] = useState({});

  return (
    <Titled
      title={title}
      size={titleSize}
      actions={[
        <ExportContacts
          className="mr-2"
          searchParams={search}
          tableFilters={tableFilters}
          disabled={!data.length}
        />,
        showUploadButton && <UploadContactButton />,
        <SelectListAction
          disabled={!selectedContactIds.length}
          selectedContactIds={selectedContactIds}
        />,
        showAddContactButton && (
          <AuthorizedLink
            to={{
              pathname: '/contacts/add',
              state: { defaultValues: { ...additionalAddFormProps } },
            }}
            className="btn btn-secondary ml-2"
            query={api.addContact}
          >
            Create Contact
          </AuthorizedLink>
        ),
      ]}
    >
      <AsyncList
        className="ReactTable--vertical-center select-table"
        keyField="id"
        setSelectedItems={setContactIds}
        setData={setData}
        selectionName="contacts"
        columns={listColumns}
        allowSelection
        onDownload={onDownload}
        searchParams={searchParams}
        setTableFilters={setTableFilters}
        {...rest}
      />
    </Titled>
  );
};

ListContacts.propTypes = {
  titleSize: string,
  onDownload: func,
  showAddContactButton: bool,
  showUploadButton: bool,
  selectListAction: func,
  title: string,
  additionalAddFormProps: object, // eslint-disable-line react/forbid-prop-types,
  search: object, // eslint-disable-line react/forbid-prop-types,
  contactListId: number,
};

ListContacts.defaultProps = {
  titleSize: undefined,
  onDownload: undefined,
  showAddContactButton: true,
  showUploadButton: true,
  selectListAction: AddToContactListModal,
  title: 'Contacts',
  additionalAddFormProps: {},
  contactListId: undefined,
  search: {},
};

export default ListContacts;
